import Link from "next/link";
import S from "./index.module.scss";
import { FC } from "react";
import { SuccessListItemType } from "@/views/success-story/constants/people";
import { useTranslations } from "next-intl";
import Image from "next/image";

const SuccessCard: FC<{ item: SuccessListItemType }> = ({ item }) => {
  const t = useTranslations("success");

  return (
    <Link className={S.wrapper} href={`/success-story/${item.slug}`}>
      <div className={S.textWrapper}>
        <p className={S.title}>{t(item.title)}</p>
        <div className={S.info}>
          <Image src={item.avatar} alt={t(item.name)} width={160} height={160} />
          <div className={S.infoText}>
            <p className={S.infoName}>{t(item.name)}</p>
            <p className={S.infoQualification}>{t(item.qualification)}</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SuccessCard;
